export default __webpack_public_path__ + "static/media/trade-in-buzzbucks.671ecf3a.png";